import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    headerTitle: {
        fontWeight: 500,
        fontSize: "20px",
        color: "rgb(36,42,56)",
    },
    reportEventBtn: {
        backgroundColor: 'rgb(241, 242, 246)',
        border: '2px solid #000000',
        height: "40px",
        width: "200px",
        borderRadius: '30px',
        fontSize: "15px",
        fontWeight: 700
    },
    info: {
        marginTop: '15px',
        backgroundColor: '#ffffff',
        height: '150px',
        width: '100%',
        overflow: 'auto',
    },
    table: {
        // overflow:"auto",
        width: '100%',
        [theme.breakpoints.down("sm")]: {
            overflow: 'hidden',
            width: "900px",
        },
    },
    tableRowHeading: {
        height: "60px",
    },
    tableRowData: {
        textAlign: 'center',
    },
    driverName: {
        fontWeight: 900
    },
    mapview: {
        height: '100px',
        backgroundColor: '#ffffff',
        width: '100%',
        marginTop: '10px'
    },
    containerMore: {
        paddingTop: '20px',
        width: '100%',
        height: 'auto',
        backgroundColor: '#ffffff',
        marginTop: '10px',
        padding: '50px',
        overflow: 'hidden'
    },
    containerLess: {
        paddingTop: '20px',
        width: '100%',
        height: '467px',
        backgroundColor: '#ffffff',
        marginTop: '10px',
        padding: '50px',
        overflow: 'hidden'
    },
    messageBox: {
        width: '100%',
        height: 'auto',
        backgroundColor: '#ffffff',
        paddingTop: '5px',
        paddingBottom: '5px',
        padding: '30px',
        marginTop: '10px'
    },
    mesgHeading: {
        fontWeight: 900
    },

    btncontainer: {
        marginTop: '10px',
        [theme.breakpoints.down("sm")]: { justifyContent: 'center', },
        // [theme.breakpoints.down("md")]: { justifyContent: 'flex-start' }
    },

    // Modal

    paper: {
        position: 'absolute',
        width: '800px',
        backgroundColor: theme.palette.background.paper,
        borderRadius: '15px',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        [theme.breakpoints.down("md")]: {
            width: '500px'
        },
        [theme.breakpoints.down("sm")]: {
            width: '375px',
        },
        [theme.breakpoints.down("xs")]: {
            width: '100%',
        },
    },
    titlePopup: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        backgroundColor: "#ssddff"
    },
    modal: {
        marginTop: '100px',
        display: 'flex',
        justifyContent: 'center',
    },
    reportEvent: {
        color: 'white',
        backgroundColor: '#ffac67',
        paddingTop: '2px',
        paddingbottom: '2px',
        width: '130px',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '10px',
    },
    titleLabel: {
        fontWeight: 800
    },
    subtitleLabel: {
        fontSize: '14px',
        color: '#a3abb6',
        whiteSpace: 'nowrap',
    },
    rejectBtn: {
        margin: "10px",
        backgroundColor: 'rgb(241, 242, 246)',
        border: '2px solid #000000',
        height: "40px",
        width: "200px",
        borderRadius: '30px',
        fontSize: "15px",
        fontWeight: 700
    },
    approveBtn: {
        margin: "10px",
        height: "40px",
        width: "200px",
        borderRadius: '30px',
        fontSize: "15px",
        fontWeight: 700,

        // [theme.breakpoints.down("xs")]: { marginTop: '10px', marginLeft: '0px' },
    },
    loadingContainer: {
        padding: "1.6em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    displayEventData: {
        marginTop: "16px",
        marginBottom: "8px"
    },
    journeyDetails: {
        fontSize: "14px",
        color: "#242a38",
        fontWeight: 900
    },
    journeyDetailsTitle: {
        fontSize: "14px",
        color: "#242a38"
    },
    journeyDetailsSubTitle: {
        fontSize: "14px",
        color: "#a7afb9"
    },
    eventHeading: { textAlign: 'left', paddingLeft: '30px', width: '300px' },
    eventRowData: { textAlign: 'left', paddingLeft: '30px', lineHeight: '0.5' },
    imgRightClickDisable: {
        pointerEvents: "none",
    },
    mapIcon: {
        width: "12pt",
        marginLeft: '13pt'
    },
    journyDate: {
        fontSize: "14px",
        color: "#242a38",
        marginTop: "5pt",
        marginBottom: "5pt"
    }
}));
